import { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { LoginContext } from "../../../../../services/api/authentication-api";

const LastActivity = ({ dataItem }) => {
  const user = useContext(LoginContext);
  const labels = user.currentUser?.objectLabels;
  let action = dataItem?.LastActivity ?? "";
    if (labels) {
      if (labels.ProjectSingular) {
        action = action.replaceAll("Project", labels.ProjectSingular);
      }
      if (labels.TaskSingular) {
        action = action.replaceAll("Task", labels.TaskSingular);
      }
      if (labels.FormSingular) {
        action = action.replaceAll("Form", labels.FormSingular);
      }
    }
  const lastActivity = action;
  const lastActivityDate = dataItem?.LastActivityDateString ?? "";

  const content = useMemo(() => (
    <>
      <span style={{ display: "block" }}>{lastActivity}</span>
      <span style={{ display: "block", fontSize: "0.85em", color: "#555" }}>
        {lastActivityDate}
      </span>
    </>
  ), [lastActivity, lastActivityDate]);

  return content;
};

LastActivity.propTypes = {
  dataItem: PropTypes.shape({
    LastActivity: PropTypes.string,
    LastActivityDateString: PropTypes.string,
  }).isRequired,
};

export default LastActivity;
